export const siteConfig = {
  name: import.meta.env.VITE_SITE_NAME ?? "key.store",
  domain: import.meta.env.VITE_SITE_DOMAIN ?? "key.store",
  title: import.meta.env.VITE_SITE_TITLE ?? "key.store - A safe place for your sensitive stuff",
  description:
    import.meta.env.VITE_SITE_DESCRIPTION ??
    "key.store keeps your passwords secure and fills them automatically. Free forever. Open source. No upsells.",
  llcName: import.meta.env.VITE_SITE_LLC_NAME ?? "key dot store, LLC",
  privacyEmail: import.meta.env.VITE_PRIVACY_EMAIL ?? "privacy@key.store",
  dmcaEmail: import.meta.env.VITE_DMCA_EMAIL ?? "dmca@key.store",
  links: {
    repo: import.meta.env.VITE_REPO_URL ?? "https://git.key.store/key-store/key.store",
    issues: import.meta.env.VITE_ISSUES_URL ?? "https://git.key.store/key-store/key.store/issues",
    releases: import.meta.env.VITE_RELEASES_URL ?? "https://git.key.store/key-store/key.store/releases",
    playStore:
      import.meta.env.VITE_PLAY_STORE_URL ??
      "https://play.google.com/store/apps/details?id=store.key.application",
    androidApk:
      import.meta.env.VITE_ANDROID_APK_URL ??
      "https://hel1.your-objectstorage.com/key-store-release/android/key.store-latest.apk",
    androidAab:
      import.meta.env.VITE_ANDROID_AAB_URL ??
      "https://hel1.your-objectstorage.com/key-store-release/android/key.store-latest.aab",
    fdroidRepo:
      import.meta.env.VITE_FDROID_REPO_URL ??
      "https://fdroid.key.store/repo",
    flatpakRepo:
      import.meta.env.VITE_FLATPAK_REPO_URL ??
      "https://key.store/keydotstore.flatpakrepo",
    sparkleDmg:
      import.meta.env.VITE_SPARKLE_DMG_URL ??
      "https://key.store/builds/sparkle/key.store-latest.dmg",
    sparkleAppcast:
      import.meta.env.VITE_SPARKLE_APPCAST_URL ??
      "https://key.store/builds/sparkle/appcast.xml",
    windowsAppInstaller:
      import.meta.env.VITE_WINDOWS_APPINSTALLER_URL ??
      "https://key.store/builds/windows/appinstaller/key.store.appinstaller",
    ledger: import.meta.env.VITE_LEDGER_URL ?? "https://money.key.store",
    graphs: import.meta.env.VITE_GRAPHS_URL ?? "https://graphs.key.store",
    traces: import.meta.env.VITE_TRACES_URL ?? "https://traces.key.store",
  },
  social: {
    bsky: import.meta.env.VITE_SOCIAL_BSKY ?? "key.store",
    x: import.meta.env.VITE_SOCIAL_X ?? "keydotstore1",
  },
} as const;
